/* pg-offer-copy */
(function(){
  if (window.pgOfferCopy) return; window.pgOfferCopy = 1;

  var EXTRA = 'plus an extra <b>5% off</b> at checkout.';
  var LAST  = 'An extra <b>5% off</b> is applied automatically at checkout.';

  /* ---------------- the deal note ---------------- */

  /* the offer tiles a shopper can actually see, in the order they read */
  function tiles(){
    var buy = document.querySelector('#pgx .pgx-buy');
    if (!buy) return [];
    var out = [];
    buy.querySelectorAll(':scope > .pgx-tile').forEach(function(t){
      if (t.offsetWidth > 0 || t.offsetHeight > 0) out.push(t);   /* skip the hidden natives */
    });
    return out;
  }

  function titleOf(tile){
    var h = tile.querySelector('.pgx-lad-t b, .pgx-duo-t b, .pgx-tile-name');
    var t = (h ? h.textContent : '').replace(/\s+/g, ' ').trim();
    return t.replace(/[<>&]/g, '');
  }

  function note(){
    var p = document.querySelector('#pgx .pgx-deal-note');
    if (!p) return;
    var ts = tiles();
    if (ts.length < 2) return;
    var i = -1;
    for (var k = 0; k < ts.length; k++){ if (ts[k].classList.contains('pgx-sel')) i = k; }
    if (i < 0) return;

    var html;
    if (i >= ts.length - 1){
      html = LAST;
    } else {
      var next = titleOf(ts[i + 1]);
      if (!next) return;
      html = 'Upgrade to <b>' + next + '</b> — ' + EXTRA;
    }
    /* compared against the node, and written with a literal em dash rather than
       an entity, so the read-back matches what was written and this settles */
    if (p.innerHTML !== html) p.innerHTML = html;
  }

  function pass(){ note(); }

  function boot(){
    pass();
    /* selection is a class on the tile, so attributes are watched too */
    var root = document.getElementById('pgx');
    if (root && window.MutationObserver){
      var q = false;
      new MutationObserver(function(){
        if (q) return;
        q = true;
        setTimeout(function(){ q = false; pass(); }, 80);
      }).observe(root, {childList: true, subtree: true, attributes: true, attributeFilter: ['class']});
    }
    /* a tap on a tile repaints the line immediately rather than on the next tick */
    document.addEventListener('click', function(e){
      if (e.target && e.target.closest && e.target.closest('#pgx .pgx-tile')) setTimeout(pass, 60);
    }, true);
    setInterval(pass, 900);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
